export const joinApiPath = {
  submitApplication: '/v2/curator/register',
  checkEligibility: '/v2/curator/check-eligibility',
  checkSnsDuplicate: '/v2/curator/sns/check-duplicate',
} as const;
